// eslint-disable-next-line no-shadow
export enum Route {
  Comments,
  Favorites,
  Readers,
  ReadLaters,
}
